<div class="row">
	<div class="table-responsive">
		<table class="table table-borderless mb-0" style="width: fit-content">
			<tbody>
				<tr style="width: 50%">
					<th class="ps-0">Numéro :</th>
					<td class="text-muted">{{ numero }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Fournisseur :</th>
					<td class="text-muted">{{ fournisseur }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Consulation :</th>
					<td class="text-muted">{{ consultation }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Numéro devis :</th>
					<td class="text-muted">{{ numeroDevis || "--" }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Date du bon de commande :</th>
					<td class="text-muted">{{ date }}</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Exporté :</th>
					<td class="text-muted">
						@if (isExporte) {
							<span class="badge rounded-pill fw-medium p-2 bg-success-subtle text-success">Oui</span>
						} @else {
							<span class="badge rounded-pill fw-medium p-2 bg-dark-subtle text-body">Non</span>
						}
					</td>
				</tr>
				<tr style="width: 50%">
					<th class="ps-0">Total prix du bon de commande :</th>
					<td class="text-muted">{{ totalPriceBC + " DH" }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
